import React from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flexbox from "flexbox-react";

import MultiSelectToolbar from "./app-multiselect-toolbar";

import { selectAllSearchItems, resetSelectedSearchItems } from "../../actions/searchActions";

class MultiSelectSearchToolbar extends React.PureComponent {
	render() {
		let multiSelectToolbar =
			<MultiSelectToolbar
				selectedItems={this.props.selectedSearchItems}
				onClickClose={() => {
					this.props.dispatch(
						resetSelectedSearchItems
					);
				}}
				onClickSelectAll={() => {
					this.props.dispatch(
						selectAllSearchItems
					);
				}}>
				<Flexbox flexDirection="row" alignItems="center">
					<div style={{ cursor: "pointer" }} onClick={() => {
					}}>
						<FontAwesomeIcon icon="trash" />
					</div>
				</Flexbox>
			</MultiSelectToolbar>;

		if (this.props.selectedSearchItems.length === 0) {
			multiSelectToolbar = null;
		}

		return multiSelectToolbar;
	}
}

export default branch({
	selectedSearchItems: ["appState", "selectedSearchItems"],
}, MultiSelectSearchToolbar);